<div class="copy-day-dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <h2 mat-dialog-title>Copy from Another Day</h2>
      <p class="dialog-subtitle">
        Select a day to copy all exercises to
        {{ weeklyTemplate[currentDayIndex].dayName }}
      </p>
    </div>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCancel()"
      title="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="days-list" *ngIf="availableDays.length > 0">
      <div *ngFor="let day of availableDays; let i = index" class="day-option">
        <div class="day-info">
          <div class="day-header">
            <h4 class="day-name">{{ day.dayName }}</h4>
            <span class="exercise-count"
              >{{ getExerciseCount(day) }} exercises</span
            >
          </div>
          <div class="exercise-sections">
            <span class="section-info warmup" *ngIf="hasWarmupExercises(day)">
              <mat-icon>whatshot</mat-icon>
              Warm Up
            </span>
            <span class="section-info main" *ngIf="hasMainExercises(day)">
              <mat-icon>fitness_center</mat-icon>
              Main
            </span>
            <span
              class="section-info cooldown"
              *ngIf="hasCooldownExercises(day)"
            >
              <mat-icon>spa</mat-icon>
              Cool Down
            </span>
          </div>
        </div>
        <button
          mat-raised-button
          color="primary"
          class="copy-button"
          (click)="copyDay(i)"
        >
          <mat-icon>content_copy</mat-icon>
          Copy
        </button>
      </div>
    </div>

    <div class="no-days-message" *ngIf="availableDays.length === 0">
      <mat-icon class="no-days-icon">info</mat-icon>
      <p>No other workout days available to copy from.</p>
      <p class="no-days-subtitle">
        All other days are either rest days or this is the only workout day.
      </p>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" (click)="onCancel()" class="cancel-button">
      Cancel
    </button>
  </div>
</div>
